import React from "react";

export default function Quotation() {
  return (
    <div>
      <h4 className="pages-h4">Quotation</h4>
    </div>
  );
}
